import { Anchor } from '@mantine/core';

type TrackingNumberColumnProps = {
  trackingNumber?: string;
  trackingUrl?: string;
};

export const TrackingNumberColumn = ({ trackingNumber, trackingUrl }: TrackingNumberColumnProps) => {
  if (!trackingNumber) {
    return null;
  }

  if (trackingUrl) {
    return (
      <Anchor href={trackingUrl} rel='noopener noreferrer' target='_blank'>
        {trackingNumber}
      </Anchor>
    );
  }

  return trackingNumber;
};
